import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import { useUserTenantTypeQuery } from "@/v2-backoffice-client/user/tenant/type/user.tenant.type.query"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypeSelectorItem from "@/v2-backoffice-client/tenant/user/type/TenantUserTypeSelectorItem"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"

export type TenantUserTypeSelectorDialogProps = {
  open: boolean
  onOpenChange(open: boolean): void
  userTenant: UserTenantFragment
}

function TenantUserTypeSelectorDialog(
  props: TenantUserTypeSelectorDialogProps,
) {
  const { open, onOpenChange, userTenant } = props

  const user = userTenant.User
  const userName = formatUserName(user?.FirstName, user?.LastName)

  const { data, loading, error } = useUserTenantTypeQuery({
    fetchPolicy: "cache-first",
  })

  errorToast(error, {
    title: "Failed to load user team types",
  })

  const userTenantTypes = data?.getUserTenantTypes ?? []

  return (
    <Selector.Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Team role for ${userName}`}
      description="Change the team role for this user."
    >
      <Selector.List
        emptyLabel="No types found"
        isLoading={loading}
        error={error}
      >
        {userTenantTypes.map((type) => (
          <TenantUserTypeSelectorItem
            key={type.Code}
            type={type}
            userTenant={userTenant}
            added={type.Code === userTenant.UserTenantTypeCode}
            onCompleted={() => {
              onOpenChange(false)
            }}
          />
        ))}
      </Selector.List>
    </Selector.Dialog>
  )
}

export default TenantUserTypeSelectorDialog
